// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

// export let API_PATH = 'http://localhost:3002/';
export let API_PATH = 'https://stg-app-api.wazir.com.br/';

/**
 * Overrides the API URL baked in at build time with one resolved at container
 * startup (Coolify env var -> docker-entrypoint.sh -> assets/env-config.json).
 * Must run before AppModule bootstraps — see main.ts.
 */
export function setApiHost(url: string): void {
  API_PATH = url.endsWith('/') ? url : `${url}/`;
}
export const IBGE_API_PATH = 'https://servicodados.ibge.gov.br/api/v1/';
export const BRASIL_API_PATH = 'https://brasilapi.com.br/api/';
export const TOAST_DURATION = 20000;
export const TOAST_POSITION = 'br';
export const AWS_BUCKET_NAME = 'gmt-admin';
export const S3_URL_BASE = `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/`;
export const ZAPSIGN_API_URL = 'https://api.zapsign.com.br/api/v1';
export const ZAPSIGN_SANDBOX_API_URL =
  'https://sandbox.api.zapsign.com.br/api/v1';
export const CANVI_API_URL = 'https://gateway-homol.service-canvi.com.br';

// Barid (agente local de dispositivos do Wazir). Loopback na mesma maquina;
// porta 47831 para conviver com o ConcentradorX do ABCX.
export const BARID_ENABLED = true;
export const BARID_BASE_URL = 'http://127.0.0.1:47831';
export const BARID_API_VERSION = '1.40.0';
export const BARID_TIMEOUT_MS = 2500;
export const BARID_EXPECTED_ENV = 'development';
